import React from 'react';

import {PushNotificationRemoveUser} from 'src/components/remove-user/push-notification-remove-user';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Tooltip} from '@pb/kit-component-popups';
import {usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    email: string,
    onRemoveHandle: (email: string) => void,
};

export const RemoveUser = ({email, onRemoveHandle}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        onCreateNote({
            id: `${email}`,
            body: () => (
                <PushNotificationRemoveUser
                    {...{
                        email,
                        onClose: onCloseNote,
                        onRemoveHandle,
                    }}
                />
            ),
            buttonProps: {iconProps: {type: Icons.CLOSE}},
            autoHideTimeout: 10000,
        });
    };

    return (
        <Tooltip
            anchor={({anchorRef}) => (
                <BasicIconButton
                    ref={anchorRef}
                    iconProps={{type: Icons.TRASH_LIGHT, size: Sizes.Size_19}}
                    onClick={onRemove}
                />
            )}>
            Delete User
        </Tooltip>
    );
};
